module.exports = __webpack_public_path__ + "TB_Powerup_Melody_A.wav.2afb4981.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_Melody_A.wav.mp3
// module id = 504
// module chunks = 0